var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuestic-file-upload-undo"},[_vm._v("\n  "+_vm._s(_vm.$t('fileUpload.fileDeleted'))+"\n  "),_c('button',{staticClass:"btn-text btn-text--primary",attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('recover')}}},[_vm._v("\n    "+_vm._s(_vm.$t('fileUpload.undo'))+"?\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89cb535c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vuestic-components/vuestic-file-upload/VuesticFileUploadUndo.vue
// module id = 0khu
// module chunks = 114